import React from "react";
import CartDrawer from "./CartDrawer";
import { useCart } from "../../contexts/CartContext";

const GlobalCart = () => {
  const { isCartOpen, setCartOpen } = useCart();

  return (
    <CartDrawer
      isOpen={isCartOpen}
      onClose={() => setCartOpen(false)}
      onOpen={() => setCartOpen(true)}
    />
  );
};

export default GlobalCart;
